import { Filters, FilterGroup, FilterRule } from '@models/common.model'

/**
 * Converts Filters object format to FilterGroup format for API requests
 * @param filters - Filters object in format { fieldName: { operator, value } }
 * @returns FilterGroup with FilterRule[] array
 */
export const convertFiltersToFilterGroup = (filters: Filters | undefined): FilterGroup | undefined => {
	if (!filters || Object.keys(filters).length === 0) {
		return undefined
	}

	const filterRules: FilterRule[] = Object.entries(filters)
		.filter(([_, filterValue]) => {
			// Only include filters that have valid operator and value
			if (!filterValue || !filterValue.operator) {
				return false
			}

			const { value } = filterValue

			// Exclude empty values based on type
			if (value === undefined || value === null) {
				return false
			}

			// For arrays, exclude empty arrays
			if (Array.isArray(value) && value.length === 0) {
				return false
			}

			// For strings, exclude empty strings
			if (typeof value === 'string' && value.trim() === '') {
				return false
			}

			return true
		})
		.map(([field, filterValue]) => {
			// Handle array values appropriately
			let value = filterValue.value

			// For "=" and "!=" operators, keep array as-is
			// For other operators, if single item array, unwrap it
			if (Array.isArray(value) && value.length === 1 && filterValue.operator !== '=' && filterValue.operator !== '!=') {
				value = value[0]
			}

			return {
				field,
				operator: filterValue.operator,
				value,
			} as FilterRule
		})

	if (filterRules.length === 0) {
		return undefined
	}

	return {
		logic: 'and',
		filters: filterRules,
	}
}

